import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "static-wheel" }
const _hoisted_2 = { class: "static-wheel__rotation-content" }
const _hoisted_3 = {
  key: 3,
  class: "wheel-speech-bubble wheel-speech-bubble--active-container"
}
const _hoisted_4 = { class: "wheel-speech-bubble__content" }

import { computed } from "vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { CanvasConfiguration } from "../spinning-wheel//models/sw-configuration";


export default /*@__PURE__*/_defineComponent({
  __name: 'static-wheel',
  props: {
    wheelConfig: {},
    enableAnimation: { type: Boolean },
    disabled: { type: Boolean },
    showLogoAsButton: { type: Boolean },
    logoBubbleText: {},
    isErrorState: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const lightsOutsideSrc = computed(() =>
    props.enableAnimation ? props.wheelConfig.assets.lightsOutside.on : props.wheelConfig.assets.lightsOutside.off
);

const wheelInsideSrc = computed(() =>
    props.disabled ? props.wheelConfig.assets.staticInsideDisabled : props.wheelConfig.assets.staticInsideOn
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WebpImage, {
      class: "static-wheel__construction",
      src: _ctx.wheelConfig.assets.wheelConstruction,
      alt: ""
    }, null, 8, ["src"]),
    _createVNode(WebpImage, {
      class: "static-wheel__outside",
      src: lightsOutsideSrc.value,
      alt: ""
    }, null, 8, ["src"]),
    (_ctx.enableAnimation)
      ? (_openBlock(), _createBlock(WebpImage, {
          key: 0,
          class: "static-wheel__pointer",
          src: props.wheelConfig.assets.wheelConstructionPointer,
          alt: ""
        }, null, 8, ["src"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(WebpImage, {
        alt: "",
        src: props.wheelConfig.assets.wheelPins,
        class: "spinning-wheel__rotation-image spinning-wheel__rotation-image--pins"
      }, null, 8, ["src"])
    ]),
    (_ctx.showLogoAsButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          disabled: "",
          class: _normalizeClass(["spinning-wheel__construction-middle spinning-wheel__spin-button", { 'spinning-wheel__spin-button--error-state': _ctx.isErrorState }])
        }, [
          (_ctx.wheelConfig.assets?.buttonGlints?.small)
            ? (_openBlock(), _createBlock(WebpImage, {
                key: 0,
                src: _ctx.wheelConfig.assets.buttonGlints.small,
                cssClass: "spinning-wheel__spin-button-glint spinning-wheel__spin-button-glint--sm",
                alt: "Furry Spin - odlesk tlačítka"
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          (_ctx.wheelConfig.assets?.buttonGlints?.large)
            ? (_openBlock(), _createBlock(WebpImage, {
                key: 1,
                src: _ctx.wheelConfig.assets.buttonGlints.large,
                cssClass: "spinning-wheel__spin-button-glint spinning-wheel__spin-button-glint--lg",
                alt: "Furry Spin - odlesk tlačítka"
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          _createVNode(WebpImage, {
            class: "static-wheel__logo-in-btn",
            src: props.wheelConfig.assets.staticLogo,
            alt: ""
          }, null, 8, ["src"])
        ], 2))
      : (_openBlock(), _createBlock(WebpImage, {
          key: 2,
          class: "static-wheel__logo",
          src: props.wheelConfig.assets.staticLogo,
          alt: ""
        }, null, 8, ["src"])),
    (_ctx.logoBubbleText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "wheel-speech-bubble__tail" }, null, -1)),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.logoBubbleText), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(WebpImage, {
      class: _normalizeClass(["static-wheel__inside", _ctx.enableAnimation ? 'static-wheel__inside--spin' : '']),
      src: wheelInsideSrc.value,
      alt: ""
    }, null, 8, ["src", "class"])
  ]))
}
}

})